/* methods used in multiple components */

const Helpers = {
  time() {
    const now = new Date()
    const hour = now.getHours()
    const min = now.getMinutes()
    return `${hour}:${min}`
  },

  copyToClipBoard(copyText, successCb) {
    navigator.permissions.query({name: 'clipboard-write'})
        .then((result) => {
          if (result.state === 'granted' || result.state === 'prompt') {
            /* write to the clipboard */
            navigator.clipboard.writeText(copyText)
                .then(() => {
                  /* clipboard successfully set */
                  successCb()
                })
                .catch(clipboardCopyFallback)
          } else {
            clipboardCopyFallback()
          }
        })
        .catch(clipboardCopyFallback)

    function clipboardCopyFallback() {
      /*
        Necessary for Safari/Firefox or situtations without clipboard access:
        -Create invisible DOM element that contains copyText
        -Focus/select DOM element
        -copy content of DOM element
        -remove DOM element
      */
      const textArea = document.createElement('textarea')
      textArea.value = copyText

      // Avoid scrolling to bottom
      textArea.style.top = '0'
      textArea.style.left = '0'
      textArea.style.position = 'fixed'

      // create DOM element, focus, select DOM element
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      // copy content of DOM element
      try {
        /*
          MDN says document.execCommand is deprecated
          but at the time of writing this (Feb 2023),
          it has wide browser support
        */
        document.execCommand('copy')
        successCb()
      } catch (err) {
        console.error('Unable to copy to clipboard: ', err)
      }
      // remove DOM element
      document.body.removeChild(textArea);
    }
  },

  timeStampToDate(timestamp) {
    const dateObj = new Date(timestamp)
    return (
      dateObj.getMonth() + 1 +
      '/' + dateObj.getDate() +
      '/' + dateObj.getFullYear()
    )
  },

  timeStampToTime(timestamp) {
    const dateObj = new Date(timestamp)
    const hours = dateObj.getHours().toString()
    const minutes = dateObj.getMinutes().toString()
    const formattedHours = hours.length === 2 ? hours : '0' + hours
    const formattedMinutes = minutes.length === 2 ? minutes : '0' + minutes
    return (
      `${formattedHours}:${formattedMinutes}`
    )
  },

  formatDate(str) {
    if (str) {
      const dashB = str.slice(5, str.length) + '/' + str.slice(0, 4)
      return dashB.replace('-', '/')
    } else {
      return ''
    }
  },

  /* Used to trigger callback after typing has stopped for pause length */
  toggleTyping(timeOfType, callback, pauseLength = 2000) {
    setTimeout(() => {
      const now = Date.now()
      if ((now - timeOfType) >= pauseLength) {
        callback()
      }
    }, pauseLength);
    return false
  },

  async fetchPostJson(url, headers, data) {
    const myHeaders = new Headers(headers)
    myHeaders.append('Content-Type', 'application/json')

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(data),
      redirect: 'follow',
      connection: 'keep-alive',
    }

    const response = await fetch(url, requestOptions)
    // parses JSON response into native JavaScript objects
    return response.json();
  },

  async fetchPost(url, headers, data) {
    const myHeaders = new Headers(headers)
    myHeaders.append('Content-Type', 'application/json')

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(data),
      redirect: 'follow',
      connection: 'keep-alive',
    }

    const response = await fetch(url, requestOptions)
    // parses JSON response into native JavaScript objects
    return response;
  },

  async fetchPostMultipart(url, headers, formdata) {
    const myHeaders = new Headers(headers)
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow',
      connection: 'keep-alive',
    }

    const response = await fetch(url, requestOptions)
    // parses JSON response into native JavaScript objects
    return response.json();
  },

  async fetchGet(url, headers) {
    const myHeaders = new Headers(headers)
    myHeaders.append('Content-Type', 'application/json')
    const requestOptions = {
      headers: myHeaders,
      redirect: 'follow',
    }

    const response = await fetch(url, requestOptions)
    // parses JSON response into native JavaScript objects
    return response.json();
  },

  async fetchGetJson(url, headers, data) {
    const myHeaders = new Headers(headers)
    myHeaders.append('Content-Type', 'application/json')
    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow',
    }
    const addition = Object.keys(data).length ?
      '?' + new URLSearchParams(data) : ''
    const response = await fetch(url + addition, requestOptions)
    return response.json()
  },

  generateZipWithFiles(files) {
    const JSZip = require('jszip')
    const zip = new JSZip()
    for (let fIndex = 0; fIndex < files.length; fIndex ++) {
      zip.file(files[fIndex].name, files[fIndex])
    }
    return zip
  },

  async zipToBase64(zip) {
    return zip.generateAsync(
        {type: 'base64'},
    ).then((base64) => {
      return base64
    })
  },

  downloadFile(fileText, fileType, fileName) {
    const blob = new Blob([fileText], {type: fileType});
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('download', fileName);
    a.click()
  },
}

export default Helpers
